/**
 * tdesign v1.11.1
 * (c) 2025 tdesign
 * @license MIT
 */

import { t as toPropertyKey } from './dep-6b7c7d34.js';

function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}

export { _defineProperty as _ };
//# sourceMappingURL=dep-8bcc0e9b.js.map
